<template>
  <div style="height: 100%">
    <div class="d-flex flex-wrap">
      <div v-for="item in paginatedItems" :key="item.id + item.parentid">
        <GridPodItem
          v-if="item.nodeid"
          :item="item"
          :asSearchResult=false
          :isDeleted=true
          :showPreviews="showPreviews"
          @toggleItemSelection="toggleItemSelectionEvent"
          @showContextMenu="showContextMenu"
          :style="getListItemStyle(item)"
          class="grid-view-item"
        />

        <GridNodeItem
          v-else
          :item="item"
          :asSearchResult=false
          :isDeleted=true
          :showPreviews="showPreviews"
          @toggleItemSelection="toggleItemSelectionEvent"
          @showContextMenu="showContextMenu"
          :style="getListItemStyle(item)"
          class="grid-view-item"
        />
      </div>

    </div>

    <div class="d-flex justify-center my-4" v-if="!noMoreItemsToLoad">
      <v-btn color="primary" @click="loadNextPage" variant="flat">
        {{ $t('routes.recycleBin.loadNextFiles', Math.min(pageSize, totalItems - paginatedItems.length)) }}
      </v-btn>

      <v-btn color="primary" class="ml-4" @click="loadAllItems" variant="flat">
        {{ $t('routes.recycleBin.showAllFiles', totalItems) }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { useRecycleBinStore } from '@/stores/RecycleBinStore.js'
import GridNodeItem from '@/routes/nodes2/components/nodeGridView/GridNodeItem.vue';
import GridPodItem from '@/routes/nodes2/components/nodeGridView/GridPodItem.vue';

export default {
  name: "RecycleBinGridView",
  components: {
    GridNodeItem,
    GridPodItem,
  },
  emits: [
    'restoreItem',
    'permanentlyDeleteItem',
    'confirmationDialogShow',
    'showContextMenu',
    "resetPaginatedItems"
  ],
  props: {
    items:{
      type: Array,
      required: true,
    },
    selectedItemsCount: {
      type: Number,
      required: true,
    },
    isShowingConfirmationDialog: {
      type: Boolean,
      default: false,
    },
    confirmationDialogErrorMessage: {
      type: String,
      default: '',
    },
    deletionInProgress: {
      type: Boolean,
      default: false,
    },
    showPreviews: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      anchorItemSelected: null,

      pageSize: 20,
      currentPage: 1,
    };
  },
  beforeUnmount() {
    this.$emit('resetPaginatedItems');
  },
  methods: {
    showContextMenu(event) {
      this.$emit('showContextMenu', event);
    },
    toggleItemSelectionEvent(eventData) {
      // this.$emit('toggleItemSelection', event);

      const indexOfItem = this.items.indexOf(eventData.item);
      const indexOfAnchor = this.items.findIndex((item) => item.id === this.anchorItemSelected?.id);

      if (indexOfAnchor < 0) {
        this.anchorItemSelected = null;
      }

      if (eventData.holdingShift) {
        this.deselectAllItems();

        if (this.anchorItemSelected !== null && this.anchorItemSelected.id !== eventData.item.id) {
          const minIndex = Math.min(indexOfAnchor, indexOfItem);
          const maxIndex = Math.max(indexOfAnchor, indexOfItem);

          for (let i = minIndex; i <= maxIndex; i++) {
            this.toggleItemSelection(this.items[i]);
          }

          return;
        }
      }

      this.toggleItemSelection(eventData.item);
      this.anchorItemSelected = eventData.item;
    },
    toggleItemSelection(item) {
      const recycleBinStore = useRecycleBinStore();
      recycleBinStore.togglePodSelection(item.id);
    },
    deselectAllItems() {
      const recycleBinStore = useRecycleBinStore();
      recycleBinStore.deselectAllPods();
    },
    loadNextPage() {
      this.currentPage++;
    },
    loadAllItems() {
      this.currentPage = Math.ceil(this.totalItems / this.pageSize);
    },
  },
  computed: {
    getListItemStyle() {
      return (item) => {
        const style = {};
        if (item.id === this.anchorItemSelected?.id) {
          style['border'] = '1px dashed #999999';
        }

        return style;
      }
    },
    totalItems() {
      return this.items.length;
    },
    paginatedItems() {
      const startIndex = 0; // Always start from the beginning for "Load more"
      const endIndex = this.currentPage * this.pageSize;
      return this.items.slice(startIndex, endIndex);
    },
    noMoreItemsToLoad() {
      return this.paginatedItems.length >= this.totalItems;
    },
  }
}
</script>

<style lang="scss" scoped>
.grid-view-item {
  float: left;
  width: 224px;
  margin: 5px;
  padding: 12px;
  height: 194px;
  border-radius: 6px;

  a {
    text-decoration: none;
    font-size: 12px;
    font-weight: 600;

    .v-theme--dark & {
      color: #FFFFFF;
    }

    .v-theme--light & {
      color: #000000;
    }
  }

  > div {
    width: 100%;
  }

  .v-theme--dark & {
    background-color: #232b36;

    &:hover {
      background-color: #373f48;
    }

    .v-chip {
      background-color: rgba(85, 85, 85, 0.7) !important;
    }
  }

  .v-theme--light & {
    background-color: #FFFFFF;

    &:hover {
      background-color: rgba(17, 17, 17,  0.1);
    }

    .v-chip {
      background-color: rgba(224, 224, 224, 0.7) !important;
    }
  }
}
</style>
